export const goalStatusValues = {
	ON_TRACK: 'ON_TRACK',
	AT_RISK: 'AT_RISK',
	OFF_TRACK: 'OFF_TRACK',
	PENDING: 'PENDING',
	DONE: 'DONE',
	CANCELLED: 'CANCELLED',
	PAUSED: 'PAUSED',
	ARCHIVED: 'ARCHIVED',
	COMPLETED: 'COMPLETED',
} as const;
